import { nestedAll } from '../../../../api/tagManage'

/** 弹窗会话内缓存，避免名录下载与上传校验重复拉全库 Tag */
let cachedRegistry = null
let loadPromise = null

/**
 * 从 nestedAll 树构建合法 Tag 名称集合。
 * 一级 name 与所有子 tagVOList[].name 均可用于打标表操作列（与后端 selectByNameSet 对齐）。
 */
export function buildValidNameSetFromNested(nestedGroups = []) {
  const names = new Set()
  nestedGroups.forEach((group) => {
    const levelOneName = String(group.name || '').trim()
    if (levelOneName) {
      names.add(levelOneName)
    }
    ;(group.tagVOList || []).forEach((child) => {
      const childName = String(child.name || '').trim()
      if (childName) {
        names.add(childName)
      }
    })
  })
  return names
}

/**
 * 加载全库 Tag 名录缓存，供名录导出与 Excel 预校验共用。
 * @param {{ forceRefresh?: boolean }} options
 */
export function loadTagNameRegistry({ forceRefresh = false } = {}) {
  if (!forceRefresh && cachedRegistry) {
    return Promise.resolve(cachedRegistry)
  }
  if (!forceRefresh && loadPromise) {
    return loadPromise
  }
  loadPromise = nestedAll('')
    .then((res) => {
      if (!res.success) {
        throw new Error(res.errMessage || '加载 Tag 库失败')
      }
      const nestedGroups = res.data || []
      cachedRegistry = {
        nestedGroups,
        validNameSet: buildValidNameSetFromNested(nestedGroups),
        loadedAt: Date.now(),
      }
      return cachedRegistry
    })
    .finally(() => {
      loadPromise = null
    })
  return loadPromise
}

/** 测试或强制刷新名录时清空内存缓存 */
export function clearTagNameRegistryCache() {
  cachedRegistry = null
  loadPromise = null
}
